export const GET_ALL_REQUESTS_URI = '/api/__contract_id__/request/';
export const GET_MY_REQUESTS_URI = '/api/__contract_id__/request/mine';
export const GET_TO_PRODUCE_REQUESTS_URI = '/api/__contract_id__/request/to-produce';
export const GET_REQUESTS_PER_STATUS_URI = '/api/__contract_id__/requests-per-status/';
export const GET_TO_PRODUCE_REQUESTS_PER_STATUS_URI = '/api/__contract_id__/requests-per-status/to-produce';
export const GET_MINE_REQUESTS_PER_STATUS_URI = '/api/__contract_id__/requests-per-status/mine';
export const GET_ALL_SHEETS_URI = '/api/__contract_id__/sheet/';
